<template>
  <div class="equipment-modal">
    <div class="equipment-grid">
      <div v-for="item in equipmentItems" :key="item.id" class="equipment-item">
        <div class="equipment-item__image">
          <img :src="item.image" :alt="item.title" />
        </div>
        <div class="equipment-item__content">
          <h4 class="equipment-item__title">{{ item.title }}</h4>
          <p class="equipment-item__description">{{ item.description }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EquipmentModalContent',
  data() {
    return {
      equipmentItems: [
        {
          id: 1,
          title: 'エステベッド',
          description: '高級エステサロンで使用されている電動リクライニングベッド。お客様に最高のリラクゼーションを提供します。',
          image: require('@/assets/img/bed.jpg')
        },
        {
          id: 2,
          title: 'タオルウォーマー',
          description: '常に清潔で温かいタオルをご用意。衛生管理も万全です。',
          image: require('@/assets/img/warmer.jpg')
        },
        {
          id: 3,
          title: 'パーテーション',
          description: 'プライバシーに配慮した個室空間。落ち着いた雰囲気で施術に集中できます。',
          image: require('@/assets/img/partition.jpg')
        },
        {
          id: 4,
          title: '冷蔵庫',
          description: 'お客様用のドリンクや化粧品の保管にご利用いただけます。',
          image: require('@/assets/img/fridge.jpg')
        },
        {
          id: 5,
          title: '音響設備',
          description: 'Bluetooth対応スピーカー完備。お好みのBGMで空間を演出できます。',
          image: require('@/assets/img/music.jpg')
        },
        {
          id: 6,
          title: 'その他備品',
          description: 'ガウン、スリッパ、アメニティなど、サロン運営に必要な備品を完備しています。',
          image: require('@/assets/img/gown.jpg')
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';
@import '@/styles/mixins.scss';

.equipment-modal {
  .equipment-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: $spacing-lg;
  }
  
  .equipment-item {
    @include card-base;
    overflow: hidden;
    transition: transform $transition-base;
    
    &:hover {
      transform: translateY(-4px);
      
      .equipment-item__image img {
        transform: scale(1.05);
      }
    }
    
    &__image {
      @include aspect-ratio(4, 3);
      overflow: hidden;
      
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: transform $transition-slow;
      }
    }
    
    &__content {
      padding: $spacing-md;
    }
    
    &__title {
      font-size: $font-size-lg;
      font-weight: 600;
      color: $primary-color;
      margin-bottom: $spacing-sm;
    }
    
    &__description {
      font-size: $font-size-sm;
      color: $gray-600;
      line-height: 1.6;
      margin: 0;
    }
  }
}</style>